import { IUsPsAddressResponse } from '@nkr/models/usps-address-response';
import { AddressValidationResult } from '@nkr/enums/address-validation-result';
import { Alert, Button, Col, Modal, Row } from 'react-bootstrap'

export interface IAddress {
    street: string,
    street2: string,
    city: string,
    state: string,
    postalCode: string
}

interface IProps {
    show: boolean,
    response: IUsPsAddressResponse,
    submittedAddresss: IAddress,
    cancelLabel?: string,
    onlyContent?: boolean,
    onUseAddress: (recommended: boolean) => void,
    onCancel: () => void
}

const AddressValidation = (props: IProps) => {
    if (props.response == null || props.submittedAddresss == null) {
        return null;
    }

    let recommendedAddress = <></>;

    if (props.response.result == AddressValidationResult.Valid || props.response.result == AddressValidationResult.Recommendation || props.response.result == AddressValidationResult.MultipleAddresses) {
        recommendedAddress = (
            <>
                <div>{props.response.address1}</div>
                {props.response.address2 && (
                    <div>{props.response.address2}</div>
                )}
                <div>{props.response.city}, {props.response.state} {props.response.zip5}{props.response.zip4 ? '-' + props.response.zip4 : ''}</div>
            </>
        );
    }

    if (props.response.result == AddressValidationResult.InvalidRequest) {
        recommendedAddress = <>We could not validate<br />your address</>
    }

    let backgroundColor = '#d9edf7';

    if (props.response.result == AddressValidationResult.Valid || props.response.result == AddressValidationResult.Recommendation) {
        backgroundColor = '#fcf8e3';
    }

    if (props.response.result == AddressValidationResult.MultipleAddresses || props.response.result == AddressValidationResult.InvalidRequest) {
        backgroundColor = '#f2dede';
    }

    const renderContents = () => {
        return (
            <>
                <div style={{ backgroundColor, padding: '10px 15px', borderRadius: 4, marginBottom: 20 }}>
                    {(props.response.result == AddressValidationResult.Valid || props.response.result == AddressValidationResult.Recommendation) && (
                        <>
                            To avoid problems, it is best to use the recommended address. If no recommended address is found, it may mean that you have entered a
                            typo or are missing some vital information that should be corrected before continuing.
                        </>
                    )}

                    {props.response.result == AddressValidationResult.MultipleAddresses && (
                        <>
                            {props.response.resultText}
                        </>
                    )}

                    {props.response.result == AddressValidationResult.InvalidRequest && (
                        <>
                            <div style={{ marginBottom: 5 }}>We were unable to validate your address due to the following reason:</div>
                            <div>{props.response.resultText}</div>
                        </>
                    )}

                    {props.response.result == AddressValidationResult.Other && (
                        <>
                            Default address: The address you entered was found but more information is needed (such as an apartment, suite, or box number) to match
                            to a specific address.
                        </>
                    )}
                </div>
                <Row>
                    <Col xs={12} lg={6} style={{ textAlign: 'center' }}>
                        <h4>Recommended Address</h4>

                        <div style={{ backgroundColor, minHeight: 115, padding: '10px 15px', borderRadius: 4, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            {(props.response.result == AddressValidationResult.Valid || props.response.result == AddressValidationResult.Recommendation) && (
                                <>
                                    <div style={{ marginBottom: 5 }}>{recommendedAddress}</div>
                                    <Button bsSize='sm' onClick={() => props.onUseAddress(true)}>Use Recommended</Button>
                                </>
                            )}

                            {props.response.result == AddressValidationResult.MultipleAddresses && (
                                <>
                                    <div style={{ marginBottom: 5 }}>{recommendedAddress}</div>
                                    <Button bsSize='sm' bsStyle='danger' onClick={props.onCancel}>Fix</Button>
                                </>
                            )}

                            {props.response.result == AddressValidationResult.InvalidRequest && (
                                <>
                                    Something went wrong and we are not able to recommend an address
                                </>
                            )}
                        </div>
                    </Col>
                    <Col xs={12} lg={6} style={{ textAlign: 'center' }}>
                        <h4>Submitted Address</h4>

                        <div style={{ backgroundColor: '#d9edf7', minHeight: 115, padding: '10px 15px', borderRadius: 4, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{ marginBottom: 5 }}>
                                <div>{props.submittedAddresss.street}</div>
                                {props.submittedAddresss.street2 && (
                                    <div>{props.submittedAddresss.street2}</div>
                                )}
                                <div>{props.submittedAddresss.city}, {props.submittedAddresss.state} {props.submittedAddresss.postalCode}</div>
                            </div>
                            <Button bsSize='sm' onClick={() => props.onUseAddress(false)}>No, this is correct</Button>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }

    if (props.onlyContent) {
        return (
            <div>
                {renderContents()}

                <div style={{ paddingTop: 10, textAlign: 'center' }}>
                    <Button bsStyle='link' bsSize='sm' onClick={props.onCancel}>{props.cancelLabel ? props.cancelLabel : 'Cancel & Return to Registration'}</Button>
                </div>
            </div>
        );
    }

    return (
        <Modal
            backdrop='static'
            show={props.show}
            onHide={props.onCancel}
        // style={{ display: 'flex', alignItems: 'center' }}
        // dialogClassName="address-validation-modal-dialog"
        >
            <Modal.Header closeButton>Confirm Address</Modal.Header>
            <Modal.Body>
                {renderContents()}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onCancel}>{props.cancelLabel ? props.cancelLabel : 'Cancel & Return to Registration'}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddressValidation;